export default __webpack_public_path__ + "static/media/EM1280.34I-39724_-23575_0.9bd39bc1.jpg";